import React, { useState, useRef } from 'react';
import CarrierHeader from '../../components/CarrierHeader';

const demoVideos = [
    {
        title: 'How to LOGIN as a Carrier',
        url: '/demovideos/carrier-login.webm',
        preview: '/demovideos/carierlogin.webp',
    },
    {
        title: 'How to SIGN UP as a Carrier',
        url: '/demovideos/carriersSignup.webm',
        preview: '/demovideos/carierregsmall.webp',
    },
    // {
    //     title: 'How are drivers allocated to you',
    //     url: '/demovideos/driver-alocationtocarrier.webm',
    //     preview: '/demovideos/home.webp',
    // },
    // {
    //     title: 'How to get in touch with a driver',
    //     url: '/demovideos/howToUseCarierDashboard.webm',
    //     preview: '/demovideos/drivers.webp',
    // },
    {
        title: 'How to use Carrier Dashboard',
        url: '/demovideos/howToUseCarierDashboard.webm',
        preview: '/demovideos/dashboard.webp',
    },
    {
        title: 'How to Purchase a Package',
        url: '/demovideos/contactingSupport.webm',
        preview: '/demovideos/contact.webp',
    },
];

const WatchFleetyDemo = () => {
    const [selected, setSelected] = useState(0);
    const [playing, setPlaying] = useState(false);
    const videoRef = useRef(null);

    React.useEffect(() => {
        setPlaying(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    }, [selected]);

    const handlePlay = () => {
        setPlaying(true);
        videoRef.current.play();
    };

    return (
        <div className="bg-gray-100 text-dark min-h-screen lg:pl-64">
            <CarrierHeader />
            <div className="w-full mx-auto px-4 py-2">
                <h1 className="text-3xl font-bold text-primary mb-6">Watch How Fleety Works</h1>
                <p className="mb-8 text-lg text-gray-700 max-w-xl">
                    Discover how Fleety is transforming driver recruiting with simplicity, speed, and transparency.
                    See how we connect carriers directly with qualified, ready-to-drive talent without middlemen, extra costs, or red tape, so your fleet stays on the road when
                    it matters most.
                </p>
                <div className="flex flex-col md:flex-row gap-3 w-full">
                    <div className="md:w-1/4">
                        <ul className="space-y-3">
                            {demoVideos.map((video, idx) => (
                                <li key={video.title}>
                                    <button
                                        className={`w-full text-left px-2 py-2 rounded transition ${
                                            selected === idx
                                                ? 'bg-primary text-white font-semibold'
                                                : 'bg-white hover:bg-primary/10'
                                        }`}
                                        onClick={() => setSelected(idx)}
                                    >
                                        {video.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:w-3/4 flex flex-col items-center">
                        <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden shadow-lg mb-4 flex items-center justify-center">
                            {/* Blurred preview background */}
                            {!playing && (
                                <img
                                    src={demoVideos[selected].preview}
                                    alt="Video preview"
                                    className="absolute inset-0 w-full h-full object-cover blur-sm scale-105 z-0"
                                    style={{ filter: 'blur(8px) brightness(0.7)' }}
                                />
                            )}
                            <video
                                key={demoVideos[selected].url}
                                ref={videoRef}
                                src={demoVideos[selected].url}
                                controls
                                className="w-full h-full relative z-10"
                                poster={demoVideos[selected].preview}
                                onPlay={() => setPlaying(true)}
                                onPause={() => setPlaying(false)}
                            >
                                Sorry, your browser doesn't support embedded videos.
                            </video>
                            {!playing && (
                                <button
                                    onClick={handlePlay}
                                    className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/60 transition z-20"
                                    style={{ pointerEvents: 'auto' }}
                                    aria-label="Play video"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="80"
                                        height="80"
                                        viewBox="0 0 80 80"
                                        fill="none"
                                    >
                                        <circle cx="40" cy="40" r="40" fill="white" fillOpacity="0.7"/>
                                        <polygon points="32,24 60,40 32,56" fill="#2563eb"/>
                                    </svg>
                                </button>
                            )}
                        </div>
                        <div className="text-lg font-medium text-primary">
                            {demoVideos[selected].title}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WatchFleetyDemo;